import { render, staticRenderFns } from "./OrganizationModal.vue?vue&type=template&id=4c8ba34a&scoped=true&"
import script from "./OrganizationModal.vue?vue&type=script&lang=js&"
export * from "./OrganizationModal.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationModal.vue?vue&type=style&index=0&id=4c8ba34a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8ba34a",
  null
  
)

export default component.exports